// extracted by mini-css-extract-plugin
export default {"content":"OnboardApply_content__6fIhk","cardWrap":"OnboardApply_cardWrap__bFEFE","btnWrap":"OnboardApply_btnWrap__gkPgj"};